import cuid from 'cuid';
import { setActiveActivity, setClockSpeed, addSegments, setCameraDistance } from './Actions';
import { ISOtoMicroseconds } from './helpers';
const initTime = Date.now();
const defaultSegment = {
    title: null,
    target: null,
    time: initTime,
    targetDistance: 250,
};
/******************************************************************************
 * Segments set a camera target, distance, and clock speed when their time comes
 *****************************************************************************/
export class SegmentCollection {
    onSceneLoad(scene, dispatch) {
        dispatch(addSegments(scene.segments));
    }
    update(store) {
        const state = store.getState();
        const seg = getCurrentSegmentIdx(state.segments, state.clock.time);
        // Switch the segment if it has changed
        if (seg && seg.internalId !== state.activeSegment.internalId) {
            this.setSegment(seg, store);
        }
    }
    setSegment(seg, store) {
        store.dispatch({ type: 'SET_ACTIVE_SEGMENT', segment: seg });
        if (seg.speed)
            store.dispatch(setClockSpeed(seg.speed));
        if (seg.targetDistance) {
            store.dispatch(setCameraDistance(seg.targetDistance));
        }
        if (seg.target === 'activity' && seg.targetId) {
            store.dispatch(setActiveActivity(seg.targetId));
        }
    }
}
/******************************************************************************
 * Helpers
 *****************************************************************************/
function getCurrentSegmentIdx(segmentsArray, time) {
    // Find the first segment whose start time has not yet been hit
    let i;
    for (i = 0; i < segmentsArray.length; i++) {
        if (time < segmentsArray[i].time)
            break;
    }
    // Return the segment just before it
    return i >= 1 ? segmentsArray[i - 1] : undefined;
}
/******************************************************************************
 * Reducers
 *****************************************************************************/
export const activeSegment = (state = defaultSegment, action) => {
    switch (action.type) {
        case 'SET_ACTIVE_SEGMENT': {
            const seg = Object.assign({}, action.segment);
            delete seg.target;
            delete seg.targetId;
            return seg;
        }
        case 'SET_TARGET_DISTANCE':
            return Object.assign(Object.assign({}, state), { targetDistance: action.targetDistance });
        default:
            return state;
    }
};
export const segments = (state = [], action) => {
    switch (action.type) {
        case 'ADD_SEGMENTS': {
            // Convert ISO time to epoch time for easier math
            const newSegments = action.segments.map(s => (Object.assign(Object.assign({}, s), { time: ISOtoMicroseconds(s.time), internalId: cuid() })));
            const segs = [...state, ...newSegments];
            segs.sort((a, b) => a.time - b.time);
            return segs;
        }
        case 'UPDATE_SEGMENT': {
            const segmentIdx = state.findIndex(s => s.segmentId === action.segment.segmentId);
            if (segmentIdx === -1)
                return state;
            // Convert ISO time to epoch time for easier math
            const segmentUpdates = Object.assign(Object.assign({}, action.segment), { time: ISOtoMicroseconds(action.segment.time), internalId: cuid() });
            const newState = [...state];
            newState[segmentIdx] = Object.assign(Object.assign({}, state[segmentIdx]), segmentUpdates);
            newState.sort((a, b) => a.time - b.time);
            return newState;
        }
        case 'DELETE_SEGMENT': {
            const delSegmentIdx = state.findIndex(s => s.segmentId === action.segmentId);
            if (delSegmentIdx === -1)
                return state;
            state.splice(delSegmentIdx, 1);
            return [...state];
        }
        default:
            return state;
    }
};
